import axios from "axios";
import {
  sessionTimeoutInterceptor,
  successToasterInterceptor,
  errorInterceptor
} from "./middlewares";

const ambienteTeste = process.env.REACT_APP_TESTE;
const baseUrlProd = ambienteTeste !== 'false' ? process.env.REACT_APP_BASE_URL_PROD : '';
const ambiente = baseUrlProd ? sessionStorage.getItem('@FPontos:ambiente') : "";

const baseUrl = ambiente === 'prod' ? baseUrlProd : process.env.REACT_APP_BASE_URL;

const api = axios.create({
  baseURL: `${baseUrl}`,
  headers: {
    "Content-Type": "application/json",
    "x-api-key": `${process.env.REACT_APP_BASE_KEY}`,
    "x-projeto": `${process.env.REACT_APP_PROJETO}`,
    Accept: "application/json",
  },
});

api.interceptors.request.use((config: any) => {
  config.headers.Authorization = localStorage.getItem("@FPontos:Admintoken") ?? localStorage.getItem("@FPontos:token") ?? "";
  return config;
});

// api.interceptors.request.use(authorizationInterceptor);


api.interceptors.response.use(undefined, sessionTimeoutInterceptor); 
api.interceptors.response.use(successToasterInterceptor);


// api.interceptors.response.use(successToasterInterceptor, errorInterceptor);

export default api;
